'use client';

import { useTranslation } from 'react-i18next';

import WebsiteIcon from '@images/Website.svg';

import { PrimaryButtonLink } from '@/components/Button';

import { HelpContainer, HelpHeader, HelpLabelButtonWrapper } from './styles';

function getValidNeedHelpUrl(raw: string | undefined): string | null {
  if (!raw?.trim()) return null;
  try {
    const parsed = new URL(raw.trim());
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return null;
    return parsed.href;
  } catch {
    return null;
  }
}

/**
 * Help component for displaying button and information to help out the user
 */

export const Help = () => {
  const { t } = useTranslation('common');

  const needHelpUrl = getValidNeedHelpUrl(process.env.NEXT_PUBLIC_NEED_HELP_URL);

  return needHelpUrl ? (
    <HelpContainer>
      <HelpHeader>{t('needHelp')}</HelpHeader>
      <HelpLabelButtonWrapper>
        <PrimaryButtonLink
          href={needHelpUrl}
          target="_blank"
          rel="noopener noreferrer"
          icon={<WebsiteIcon />}
          label={t('needHelpButton')}
        />
      </HelpLabelButtonWrapper>
    </HelpContainer>
  ) : null;
};
